/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  Button,
  Box,
  Card,
  // Modal,
  CardContent,
  CardHeader,
  Stack,
  Typography,
  Avatar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  // IconButton,
  FormLabel
} from '@mui/material';
import dateFormat from 'dateformat';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
// import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
// import { Close } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import AuditAction from '../../store/actions/AuditAction';
import ContentLoader from '../../utils/errorPages/ContentLoader';

function AuditTrialDetail({ code, openmodal, onCloseModal }) {
  const [data, setData] = useState({});

  const [arrayDetails, setArrayDetails] = useState([]);
  const [objDetails, setObjDetails] = useState({});
  const [createDetails, setCreateDetails] = useState({});

  // const { code } = useParams();
  const dispatch = useDispatch();

  const { REACT_APP_API_URL } = process.env;
  // Replace 'data' with your reducer name
  const { auditItemData, isLoading } = useSelector((state) => state.audit);
  // const navigate = useNavigate();
  useEffect(() => {
    dispatch(AuditAction.getItem(code));
  }, [dispatch]);

  useEffect(() => {
    if (auditItemData) {
      setData(auditItemData);
    }
  }, [auditItemData]);

  const formatKey = (key) => {
    return key.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const modelStyle = {
    zIndex: '99999'
    // '.MuiCard-root ': {
    //   '.MuiCardContent-root': {
    //     maxWidth: '100% !important',
    //     padding: '20px !important'
    //   }
    // }
  };

  // useEffect(() => {
  //   if (data && data.details) {
  //     if (Array.isArray(data.details)) {
  //       setArrayDetails(data.details);
  //     } else {
  //       if (data.details?.createdField) {
  //         setCreateDetails(data.details.createdField);
  //       }
  //       setObjDetails(data.details);
  //     }
  //   }
  // }, [data]);

  useEffect(() => {
    if (data && data.details) {
      if (Array.isArray(data.details)) {
        console.log(data.details, 'data.details');
        // If data.details is an array, set arrayDetails state
        setArrayDetails(data.details);
        setCreateDetails(null); // Clear createDetails state
        setObjDetails(null); // Clear objDetails state
      } else {
        const objectValue = data.details;
        setCreateDetails(null); // Clear createDetails state if createdField doesn't exist
        setObjDetails(objectValue);
        setArrayDetails(null); // Clear arrayDetails state
        // Object.keys(data.details).map((key) => console.log(key, 'key'));
        if (objectValue?.createdField !== undefined && objectValue?.createdField !== null) {
          console.log('hi');
          // If createdField exists in data.details, set createDetails state
          setCreateDetails(objectValue?.createdField);
          setArrayDetails(null); // Clear arrayDetails state
          setObjDetails(null); // Clear objDetails state
        }
      }
    } else {
      // Handle the case when data or data.details is null
      setArrayDetails(null); // Clear arrayDetails state
      setCreateDetails(null); // Clear createDetails state
      setObjDetails(null); // Clear objDetails state
    }
  }, [data]);

  // function stringAvatar(name) {
  //   return {
  //     children: `${name.split('')[0][0]}${name.split('')[1][0]}`
  //   };
  // }

  function stringAvatar(name) {
    // Check if name is defined
    if (typeof name === 'string') {
      // Split the name into an array of words
      const nameParts = name.split('');
      // Check if the name has at least two parts (first name and last name)
      if (nameParts.length >= 2) {
        // Take the first letter of the first word (first name)
        const firstNameInitial = nameParts[0][0];
        // Take the first letter of the second word (last name)
        const lastNameInitial = nameParts[1][0];
        // Concatenate the initials and return as the value of the children property
        return {
          children: `${firstNameInitial}${lastNameInitial}`
        };
      }
    }
    // Return a default value if name is not defined or does not have at least two parts
    return {
      children: '?'
    };
  }

  // // Parse details string into an object with default empty objects
  // const { after = {}, before = {} } = JSON.parse(data?.details ?? '{}');
  // // Mapping details for table rows
  // const rows = Object.keys(after).map((key) => ({
  //   key,
  //   beforeValue: before[key] ?? '', // Provide default value if before[key] is undefined
  //   afterValue: after[key]
  // }));

  // let content;
  // if (data && data.details) {
  //   if (Array.isArray(data.details)) {
  //     content = (
  //       <Box sx={{ bgcolor: 'white', mt: 4 }} className="dataTable__wrap">
  //         <TableContainer component={Paper}>
  //           <Table aria-label="simple table">
  //             <TableHead>
  //               <TableRow>
  //                 <TableCell>Field</TableCell>
  //                 <TableCell>Before</TableCell>
  //                 <TableCell>After</TableCell>
  //               </TableRow>
  //             </TableHead>
  //             <TableBody>
  //               {data.details.map((item, index) => (
  //                 <TableRow key={index}>
  //                   <TableCell component="th" scope="row">
  //                     {item.field_name}
  //                   </TableCell>
  //                   <TableCell>
  //                     <Typography noWrap component="p" variant="body1" sx={{ maxWidth: '250px' }}>
  //                       {item.before}
  //                     </Typography>
  //                   </TableCell>
  //                   <TableCell>
  //                     <Typography noWrap component="p" variant="body1" sx={{ maxWidth: '250px' }}>
  //                       {item.after}
  //                     </Typography>
  //                   </TableCell>
  //                 </TableRow>
  //               ))}
  //             </TableBody>
  //           </Table>
  //         </TableContainer>
  //       </Box>
  //     );
  //   } else {
  //     content = (
  //       <Box sx={{ bgcolor: 'white', mt: 4 }} className="dataTable__wrap">
  //         <TableContainer component={Paper}>
  //           <Table aria-label="simple table">
  //             <TableBody>
  //               {Object.keys(data.details).map((key) => (
  //                 <TableRow key={key}>
  //                   <TableCell>{key}</TableCell>
  //                   {/* <TableCell>{data.details[key]}</TableCell> */}
  //                 </TableRow>
  //               ))}
  //             </TableBody>
  //           </Table>
  //         </TableContainer>
  //       </Box>
  //     );
  //   }
  // } else {
  //   content = 'hi';
  // }

  /* Payment Request -update */
  const renderInvoiceDetails = (details, type) => {
    // console.log(details, 'details');
    return (
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              {/* <TableCell>Type</TableCell> */}
              <TableCell>Service From</TableCell>
              <TableCell>Service To</TableCell>
              <TableCell>Service Description</TableCell>
              <TableCell>Quantity</TableCell>
              <TableCell>Rate</TableCell>
              <TableCell>UOM Name</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {details &&
              details.map((detail, index) => (
                <TableRow key={`${type}-${index}`}>
                  <TableCell>{detail.service_from}</TableCell>
                  <TableCell>{detail.service_to}</TableCell>
                  <TableCell>{detail.service_description}</TableCell>
                  <TableCell>{detail.quantity}</TableCell>
                  <TableCell>{detail.rate}</TableCell>
                  <TableCell>{detail.uom_name}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  // const renderField = (field) => (
  //   <TableRow key={field.field_name}>
  //     <TableCell>{field.field_name}</TableCell>
  //     <TableCell>{field.before}</TableCell>
  //     <TableCell>{field.after}</TableCell>
  //   </TableRow>
  // );

  console.log(JSON.stringify(objDetails), 'objDetails');
  const actionLabels = ['index', 'store', 'show', 'update', 'destroy'];

  return (
    <Dialog
      className="cmn__delete__modal"
      open={openmodal}
      maxWidth="lg"
      fullWidth
      sx={modelStyle}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <DialogTitle id="scroll-dialog-title">Audit Trail View</DialogTitle>
      <DialogContent>
        {isLoading ? <ContentLoader /> : ''}
        <Box className="cardWrapper">
          {/* <div className="pageTitleWrap">
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="text" component={Link} to="/payment-request">
                Audit Trail
              </Typography>
              <Typography component="h2" variant="h2">
                / View
              </Typography>
            </Stack>
          </div> */}
          <Card
            sx={{
              background: '#f9fafc !important',
              boxShadow: 'none'
            }}
          >
            <CardContent>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Box>
                  <Stack direction="row" spacing={3} alignItems="center">
                    <Avatar
                      {...stringAvatar(data?.user_name)}
                      sx={{
                        width: 120,
                        height: 120,
                        fontSize: '50px',
                        textTransform: 'uppercase',
                        bgcolor: '#002C3E'
                      }}
                    />
                    <Box>
                      <Typography
                        component="h2"
                        variant="h2"
                        sx={{ fontSize: '24px', fontWeight: '700' }}
                      >
                        {data?.user_name}
                      </Typography>
                      <Typography component="p" variant="body1">
                        {data?.user_email}
                      </Typography>
                      <Typography
                        variant="body1"
                        component="p"
                        sx={{ fontSize: '16px', fontWeight: '700', mt: 0.5 }}
                      >
                        <FormLabel sx={{ mr: 1 }}>IP :</FormLabel>
                        {data?.ip_address || ''}
                      </Typography>
                    </Box>
                  </Stack>
                </Box>
                <Box>
                  <Typography component="p" variant="body1" sx={{ my: 1, fontWeight: 700 }}>
                    <FormLabel sx={{ mr: 1 }}>Module :</FormLabel>
                    {data?.module_name || ''}
                  </Typography>
                  <Typography component="p" variant="body1" sx={{ my: 1, fontWeight: 700 }}>
                    {dateFormat(data?.timestamp, 'fullDate')}
                  </Typography>
                  <Typography variant="body1" sx={{ my: 1, fontWeight: 700 }}>
                    <FormLabel sx={{ mr: 1 }}>Event :</FormLabel>
                    {data?.event_type || ''}
                  </Typography>
                  <Typography variant="body1" sx={{ my: 1, fontWeight: 700 }}>
                    <FormLabel sx={{ mr: 1 }}>Record ID :</FormLabel>
                    {data?.unique_id || ''}
                  </Typography>
                </Box>
              </Stack>
              {arrayDetails !== null && arrayDetails.length > 0 ? (
                <>
                  <Box sx={{ bgcolor: 'white', mt: 4 }} className="dataTable__wrap">
                    <TableContainer component={Paper}>
                      <Table aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell>Field</TableCell>
                            <TableCell>Before</TableCell>
                            <TableCell>After</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {arrayDetails.map((item, index) => {
                            if (item.field_name !== 'Invoice details') {
                              return (
                                <TableRow key={index}>
                                  <TableCell component="th" scope="row">
                                    {item.field_name}
                                  </TableCell>
                                  {/* <TableCell>
                                    <Typography
                                      noWrap
                                      title={item.before}
                                      component="p"
                                      variant="body1"
                                      sx={{ maxWidth: '250px' }}>
                                      {item.before}
                                    </Typography>
                                  </TableCell> */}
                                  {item.field_name === 'Time Sheet' ? (
                                    <TableCell>
                                      {item.before.split(',').map((file, idx) => (
                                        <Typography
                                          noWrap
                                          title={file}
                                          sx={{ maxWidth: '200px', display: 'block' }}
                                          key={idx}
                                          component={Link}
                                          target="_blank"
                                          to={`${REACT_APP_API_URL}/${file}`}
                                        >
                                          {file}
                                        </Typography>
                                      ))}
                                    </TableCell>
                                  ) : (
                                    <TableCell>
                                      {item.field_name === 'Signature' ||
                                      item.field_name === 'Logo' ? (
                                        <div>
                                          <img
                                            src={`${REACT_APP_API_URL}/${item.before}`}
                                            alt="Velan Logo"
                                            width="180"
                                            height="45"
                                          />
                                        </div>
                                      ) : (
                                        <Typography
                                          noWrap
                                          title={item.before}
                                          component="p"
                                          variant="body1"
                                          sx={{ maxWidth: '250px' }}
                                        >
                                          {item.before}
                                        </Typography>
                                      )}
                                    </TableCell>
                                  )}
                                  {/* <TableCell>
                                    <Typography
                                      noWrap
                                      title={item.after}
                                      component="p"
                                      variant="body1"
                                      sx={{ maxWidth: '250px' }}>
                                      {item.after}
                                    </Typography>
                                  </TableCell> */}
                                  {item.field_name === 'Time Sheet' ? (
                                    <TableCell>
                                      {item.after.split(',').map((file, idx) => (
                                        <Typography
                                          noWrap
                                          title={file}
                                          sx={{ maxWidth: '200px', display: 'block' }}
                                          key={idx}
                                          component={Link}
                                          target="_blank"
                                          to={`${REACT_APP_API_URL}/${file}`}
                                        >
                                          {file}
                                        </Typography>
                                      ))}
                                    </TableCell>
                                  ) : (
                                    <TableCell>
                                      {item.field_name === 'Signature' ||
                                      item.field_name === 'Logo' ? (
                                        <div>
                                          <img
                                            src={`${REACT_APP_API_URL}/${item.after}`}
                                            alt="Velan Logo"
                                            width="180"
                                            height="45"
                                          />
                                        </div>
                                      ) : (
                                        <Typography
                                          noWrap
                                          title={item.after}
                                          component="p"
                                          variant="body1"
                                          sx={{ maxWidth: '250px' }}
                                        >
                                          {item.after}
                                        </Typography>
                                      )}
                                    </TableCell>
                                  )}
                                </TableRow>
                              );
                            }
                            return false;
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                  <Box sx={{ bgcolor: 'white', mt: 4 }} className="dataTable__wrap">
                    {arrayDetails &&
                      arrayDetails.map((field) => {
                        if (field.field_name === 'Invoice details') {
                          return (
                            <React.Fragment key={field.field_name}>
                              <Card>
                                <CardHeader title={field.field_name} />
                                <CardContent>
                                  <Typography component="p" variant="body1" sx={{ my: 2 }}>
                                    Before
                                  </Typography>
                                  {renderInvoiceDetails(field.before, 'Before')}
                                  <Typography component="p" variant="body1" sx={{ my: 2 }}>
                                    After
                                  </Typography>
                                  {renderInvoiceDetails(field.after, 'After')}
                                </CardContent>
                              </Card>
                            </React.Fragment>
                          );
                        }
                        return false;
                      })}
                  </Box>
                </>
              ) : (
                ''
              )}
              {createDetails !== null ? (
                <Box sx={{ bgcolor: 'white', mt: 4 }} className="dataTable__wrap">
                  <TableContainer component={Paper}>
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Field</TableCell>
                          <TableCell>Value</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {Object.entries(createDetails || {}).map(([key, value]) => (
                          <TableRow key={value}>
                            <TableCell>{formatKey(key)}</TableCell>
                            <TableCell>{value}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              ) : (
                ''
              )}

              {objDetails !== null && data?.event_type === 'Remainder Invoice' ? (
                <Box sx={{ bgcolor: 'white', mt: 4 }} className="dataTable__wrap">
                  <TableContainer component={Paper}>
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Field</TableCell>
                          <TableCell>Value</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {Object.entries(objDetails || {}).map(([key, value]) => (
                          <TableRow key={value}>
                            <TableCell>{formatKey(key)}</TableCell>
                            <TableCell>{value}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              ) : (
                ''
              )}
              {objDetails !== null &&
              (data?.event_type === 'Payment Failed' ||
                data?.event_type === 'Already paid' ||
                data?.event_type === 'Failed to Create Payment Intend' ||
                data?.event_type === 'Failed To Create Paypal Link') ? (
                <Box sx={{ bgcolor: 'white', mt: 4 }} className="cardWrapper">
                  <Card>
                    <CardHeader title="Message" sx={{ bgcolor: '#ccc !important' }} />
                    <CardContent sx={{ p: '10px 20px !Important', bgcolor: '#e7e7e7' }}>
                      <code style={{ whiteSpace: 'pre-wrap' }}>
                        {JSON.stringify(objDetails, null, 2)}
                      </code>
                    </CardContent>
                  </Card>
                </Box>
              ) : (
                ''
              )}

              {objDetails !== null && data?.event_type === 'Assigned role permissions' ? (
                <Box sx={{ bgcolor: 'white', mt: 4 }} className="dataTable__wrap">
                  <TableContainer component={Paper}>
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Field</TableCell>
                          <TableCell>Value</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {Object.entries(objDetails?.role || {}).map(([key, value]) => (
                          <TableRow key={value}>
                            <TableCell>{key}</TableCell>
                            <TableCell>{value}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TableContainer component={Card} sx={{ mt: 2 }}>
                    <CardHeader title="Permissions" />
                    <CardContent>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ textTransform: 'capitalize' }}>Modules</TableCell>
                            {actionLabels.map((label) => (
                              <TableCell
                                key={label}
                                align="center"
                                sx={{
                                  textTransform: 'capitalize'
                                }}
                              >
                                {label}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {objDetails &&
                            typeof objDetails.permissions === 'object' &&
                            objDetails.permissions !== null &&
                            Object.entries(objDetails.permissions).map(([resource, actions]) => (
                              <TableRow key={resource}>
                                <TableCell
                                  component="th"
                                  scope="row"
                                  sx={{
                                    textTransform: 'capitalize'
                                  }}
                                >
                                  {resource}
                                </TableCell>
                                {actionLabels.map((label) => (
                                  <TableCell key={`${resource}-${label}`} align="center">
                                    {actions.some((action) => action.name === label) ? '✔️' : '❌'}
                                  </TableCell>
                                ))}
                              </TableRow>
                            ))}
                        </TableBody>
                      </Table>
                    </CardContent>
                  </TableContainer>
                </Box>
              ) : (
                ''
              )}

              {objDetails !== null && data?.event_type === 'Assigned permissions to user' ? (
                <Box sx={{ bgcolor: 'white', mt: 4 }} className="dataTable__wrap">
                  <TableContainer component={Paper}>
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Field</TableCell>
                          <TableCell>Value</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {Object.entries(objDetails?.user || {}).map(([key, value]) => (
                          <TableRow key={value}>
                            <TableCell>{key}</TableCell>
                            <TableCell>{value}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TableContainer component={Card} sx={{ mt: 2 }}>
                    <CardHeader title="Permissions" />
                    <CardContent>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ textTransform: 'capitalize' }}>Modules</TableCell>
                            {actionLabels.map((label) => (
                              <TableCell
                                key={label}
                                align="center"
                                sx={{
                                  textTransform: 'capitalize'
                                }}
                              >
                                {label}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {objDetails &&
                            typeof objDetails.permissions === 'object' &&
                            objDetails.permissions !== null &&
                            Object.entries(objDetails.permissions).map(([resource, actions]) => (
                              <TableRow key={resource}>
                                <TableCell
                                  component="th"
                                  scope="row"
                                  sx={{
                                    textTransform: 'capitalize'
                                  }}
                                >
                                  {resource}
                                </TableCell>
                                {actionLabels.map((label) => (
                                  <TableCell key={`${resource}-${label}`} align="center">
                                    {actions.some((action) => action.name === label) ? '✔️' : '❌'}
                                  </TableCell>
                                ))}
                              </TableRow>
                            ))}
                        </TableBody>
                      </Table>
                    </CardContent>
                  </TableContainer>
                </Box>
              ) : (
                ''
              )}

              {objDetails !== null && objDetails?.deletedField ? (
                <Box sx={{ bgcolor: 'white', mt: 4 }} className="dataTable__wrap">
                  <TableContainer component={Paper}>
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Field Name</TableCell>
                          <TableCell>Field Value</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {Object.entries(objDetails?.deletedField).map(([key, value]) => (
                          <TableRow key={value}>
                            <TableCell>{key}</TableCell>
                            {key === 'Time Sheet' ? (
                              <TableCell>
                                <Typography
                                  component={Link}
                                  target="_blank"
                                  to={`${REACT_APP_API_URL}/${value}`}
                                >
                                  {value}
                                </Typography>
                              </TableCell>
                            ) : (
                              <TableCell>{value}</TableCell>
                            )}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              ) : (
                ''
              )}
            </CardContent>
          </Card>
          {/* <Card sx={{ maxWidth: '1180px', mt: 3 }}>
            <CardContent sx={{ textAlign: 'center' }}>
           
            </CardContent>
          </Card> */}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          type="button"
          className="cancel__btn"
          variant="contained"
          color="primary"
          size="small"
          onClick={() => {
            // navigate(`/audit-trial`);
            onCloseModal();
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

AuditTrialDetail.propTypes = {
  code: PropTypes.string.isRequired,
  openmodal: PropTypes.string.isRequired,
  onCloseModal: PropTypes.func.isRequired
};

export default AuditTrialDetail;
